import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { User, UserManager } from 'oidc-client';

import { AuthService, getLinkClientSettings } from '../auth.service';

@Component({
  selector: 'xrm-link-callback',
  templateUrl: './link-callback.component.html',
  styleUrls: ['./link-callback.component.scss']
})
export class LinkCallbackComponent implements OnInit {
  private manager: UserManager = new UserManager(getLinkClientSettings());
  private loopUser: User;

  ngOnInit() {
    this.manager.signinRedirectCallback().then(user => {
      this.loopUser = user;
      this.http.post('/security/users/linkLoopAccount', { loopUserId: user.profile.sub }).subscribe(data => {
      
      });
    });
  }

  constructor(private http: ApplicationHttpClient) {}
}
